import { callApi } from 'utils';
import { put } from 'redux-saga/effects';
import { reduxNotificationAction } from 'components/redux-notification/actions';
import { REDUX_NOTIFICATION_TYPES } from 'components/redux-notification';
import { hideDialogAction, setDialogDataAction } from 'components/redux-dialog/actions';
import { GENERATE_THUMBNAIL_DIALOG } from 'pages/my-videos.page/edit.page/fragments/thumbnail';

export function* generateThumbnailRequestEffect({ payload: { videoId, timestamp } }) {
  try {
    /** @type {videoModel.thumbnailType} */
    const thumbnailResponse = yield callApi(`videos/${videoId}/thumbnail`, 'POST', {
      timestamp,
    });

    yield put(setDialogDataAction(GENERATE_THUMBNAIL_DIALOG, thumbnailResponse));

    yield put(hideDialogAction(GENERATE_THUMBNAIL_DIALOG));
  } catch (error) {
    if (error.status === 400) {
      yield put(
        reduxNotificationAction('The thumbnail at exact time already exists.', true, 5, REDUX_NOTIFICATION_TYPES.ERROR)
      );
    }

    if (error.status === 500) {
      yield put(
        reduxNotificationAction(
          "Unfortunately, we can't create new thumbnail at the moment. Please try later.",
          true,
          5,
          REDUX_NOTIFICATION_TYPES.ERROR
        )
      );
    }
  }
}
